import { isLargeScreenViewportUtil } from 'modules/viewport/utils.js'
import { isBotUserAgentUtil } from 'modules/user-agent/utils/is-bot/index.js'

export default function getItemsCountHorizontalFlatListSelectUtil (viewport) {
  if (isLargeScreenViewportUtil(viewport)) {
    return 6
  }

  if (isBotUserAgentUtil()) {
    return 2
  }

  return 3
}
